import script from "./Autocomplete.vue?vue&type=script&lang=ts&setup=true"
export * from "./Autocomplete.vue?vue&type=script&lang=ts&setup=true"

import "./Autocomplete.vue?vue&type=style&index=0&id=af8b8fcc&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af8b8fcc"]])

export default __exports__